import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { login } from "@/cms/api";

const AdminLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bem-vinda, Isa.");
      nav("/admin", { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Erro ao autenticar";
      setError(typeof msg === "string" ? msg : "Credenciais inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center py-16 px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.7, 0, 0.15, 1] }}
        className="w-full max-w-md"
      >
        <Link to="/" className="overline text-[#6B6554] hover:text-[#3A3524] transition-colors">
          ← ORDO by Isa
        </Link>
        <h1 className="font-serif text-5xl md:text-6xl leading-[1] text-[#3A3524] mt-6 mb-2 tracking-tight">
          Bastidores.
        </h1>
        <p className="font-serif italic text-[#8C714D] text-xl mb-12">Área privada.</p>

        <form onSubmit={submit} data-testid="admin-login-form" className="flex flex-col gap-2">
          <label className="overline text-[#6B6554]">Email</label>
          <input
            data-testid="admin-email"
            type="email"
            className="ordo-field"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
          <div className="h-4" />
          <label className="overline text-[#6B6554]">Password</label>
          <input
            data-testid="admin-password"
            type="password"
            className="ordo-field"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {error && (
            <div data-testid="admin-login-error" className="mt-4 text-sm text-[#8C1D18]">
              {error}
            </div>
          )}

          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="mt-10 inline-flex items-center justify-between gap-6 bg-[#3A3524] text-[#F5F2EC] px-8 py-4 uppercase tracking-[0.28em] text-[11px] hover:bg-[#8C714D] transition-colors duration-500 disabled:opacity-60"
          >
            <span>{loading ? "A entrar…" : "Entrar"}</span>
            <span aria-hidden>→</span>
          </button>
        </form>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
